/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var fetch = MoyaContainer.get('core.fetch');
    var MoyaOverlayClass = MoyaContainer.get('core.overlay').OverlayClass;
    var OverlayStyle;
    (function (OverlayStyle) {
        OverlayStyle["DARK"] = "dark";
        OverlayStyle["LIGHT"] = "light";
    })(OverlayStyle || (OverlayStyle = {}));
    MoyaComponents.register('ext.multiform', function (el) {
        var toggles = el.querySelectorAll('.multiform-toggle');
        var selectedForm = el.querySelector('#multiform-selected-form');
        util.delegate(el, 'click', '.multiform-toggle', function (e) {
            var clickedToggle = e.delegateTarget;
            if (!isOpen(clickedToggle)) {
                clickedToggle.setAttribute('aria-expanded', 'true');
                // Set "data-selected" on parent, only for some styling
                clickedToggle.parentElement.classList.add('selected');
                Array.from(toggles).filter(function (toggle) {
                    return toggle !== clickedToggle;
                }).forEach(function (toggle) {
                    toggle.setAttribute('aria-expanded', 'false');
                    toggle.parentElement.classList.remove('selected');
                });
                replaceSelectedForm(clickedToggle.dataset.codename);
                updateQueryParam(clickedToggle.dataset.codename);
            }
        });
        function replaceSelectedForm(codename) {
            var url = window.location.pathname + ("?form=" + codename);
            var fetchOpts = {
                url: url
            };
            var overlay = new MoyaOverlayClass(el, { style: OverlayStyle.LIGHT });
            overlay.show("spinner" /* SPINNER */);
            fetch.fetchHtml(fetchOpts)
                .then(function (res) {
                var newForm = res.querySelector('#multiform-selected-form');
                if (newForm) {
                    selectedForm.innerHTML = newForm.innerHTML;
                }
            })
                .finally(function () {
                overlay.hide();
            });
        }
        function updateQueryParam(codename) {
            var query = '?form=' + codename;
            window.history.replaceState('', '', query);
        }
        function isOpen(toggle) {
            return toggle.getAttribute('aria-expanded') === 'true';
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
